import React, { lazy, Suspense, useEffect } from "react";
// import Landing from "views/examples/Landing.js";
import Login from "views/examples/Login.js";
// import Profile from "views/examples/Profile.js";
// import Register from "views/examples/Register.js";
import Spinner from "components/spinner.js";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { showSpinner, hideSpinner, fetchAllStudent } from "./action/actions";
import { setAuth } from "./action/auth";
import PrivateRoute from "./ProtectedRoute.js";
import PublishReady from "views/PublishReady";
import OfflineSyncScore from "views/OfflineSyncScore";
import OfflineSyncStudent from "views/OfflineSyncStudent";
import FlagedQuestion from "views/FlagedQuestion";

const AssignTest = lazy(() => import("views/AssignTest.js"));
const Analytics = lazy(() => import("views/Analytics.js"));
const Home = lazy(() => import("views/Home.js"));
const Profile = lazy(() => import("views/Profile.js"));
const TestView = lazy(() => import("views/TestView/index.js"));
const Survey = lazy(() => import("views/Survey.js"));
const Feedback = lazy(() => import("views/Feedback.js"));
const SurveyListStudent = lazy(() => import("views/SurveyListStudent"));
const Test = lazy(() => import("views/test"));
const TestGroupWise = lazy(() => import("views/testGroupWise"));
const TestStudent = lazy(() => import("views/testStudent"));
const Reported = lazy(() => import("views/reported"));
const ReportedStudents = lazy(() => import("views/reportedStudents"));
const ReportedView = lazy(() => import("views/ReportedView"));
const SuperAdmin = lazy(() => import("views/SuperAdmin"));
// import("views/test");

const pathWithoutSidebar = /login/gi; //add more path separate with pipe | operator
// const showSideBar = !pathWithoutSidebar.test(window.location.pathname);

const App = (parent) => {
  // useEffect(() => {
  //   parent.fetchAllStudent();
  // }, []);

  return (
    <BrowserRouter>
      {parent.globalState.spinner ? <Spinner /> : null}
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route
            path="/login"
            render={(props) => <Login {...props} {...parent} />}
          />

          <PrivateRoute path="/" exact component={Home} />

          <PrivateRoute exact path="/assign-test" component={AssignTest} />

          {/* <PrivateRoute path="/student/:id/:gradeId" component={Profile} /> */}
          <PrivateRoute path="/student" component={Profile} />

          <PrivateRoute exact path="/survey" component={SurveyListStudent} />

          <PrivateRoute path="/survey/:sid/:pid" component={Survey} />

          {/* <PrivateRoute path="/test/:uid/:tid/:gid" component={TestView} /> */}
          <PrivateRoute
            path="/test-list/:testName/summary"
            // path="/test-list/summary"
            component={TestView}
          />

          <PrivateRoute exact path="/feedback" component={Feedback} />

          {/* <PrivateRoute exact path="/test" component={Test} /> */}
          <PrivateRoute exact path="/test-list" component={Test} />

          <PrivateRoute
            exact
            path="/test-list-groupwise"
            component={TestGroupWise}
          />

          <PrivateRoute
            exact
            // path="/test/:testId/:testName"
            path="/test-list/:testName"
            component={TestStudent}
          />

          <PrivateRoute exact path="/reported-list" component={Reported} />
          <PrivateRoute
            exact
            path="/reported-list/:testName"
            component={ReportedStudents}
          />
          <PrivateRoute
            path="/reported-list/:testName/summary"
            component={ReportedView}
          />

          <PrivateRoute path="/analytics" component={Analytics} />
          <PrivateRoute path="/register-students" component={SuperAdmin} />
          <PrivateRoute path="/publish" component={PublishReady} />
          <PrivateRoute path="/sync-score" component={OfflineSyncScore} />
          <PrivateRoute path="/sync-result" component={OfflineSyncStudent} />
          <PrivateRoute path="/flag-questions" component={FlagedQuestion} />

          <Redirect to="/" />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

const mapToProp = (state) => {
  return {
    globalState: state.globaReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showSpinner: () => dispatch(showSpinner()),
    hideSpinner: () => dispatch(hideSpinner()),
    fetchAllStudent: () => dispatch(fetchAllStudent()),
    setAuth: () => dispatch(setAuth()),
  };
};

export default connect(mapToProp, mapDispatchToProps)(App);
